import { render } from "./MsNumber.vue?vue&type=template&id=77e7da11&scoped=true"
import script from "./MsNumber.vue?vue&type=script&lang=js"
export * from "./MsNumber.vue?vue&type=script&lang=js"

import "./MsNumber.vue?vue&type=style&index=0&id=77e7da11&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e7da11"]])

export default __exports__